import { useIntl } from 'react-intl'
import { FirstPurchase } from 'typings'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { IconUser, Text } from '@vtex/admin-ui'
import { messages } from './messages'
import { Tag } from '../../../Tag'

type Props = {
  config: FirstPurchase | undefined
  onEdit: () => void
  onRemove: () => void
}

export function FirstPurchaseView(props: Props) {
  const { config, onEdit, onRemove } = props

  const { $t } = useIntl()

  if (!config) return null

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconUser />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
        })}
      </RuleDescription>

      <RuleContent>
        <Tag> {$t(messages.login[config.login].title)} </Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
